import { render, staticRenderFns } from "./InchOrMmInput.vue?vue&type=template&id=10a99016&scoped=true&"
import script from "./InchOrMmInput.vue?vue&type=script&lang=js&"
export * from "./InchOrMmInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a99016",
  null
  
)

export default component.exports